module.exports = __webpack_public_path__ + "img/RecordOrganizer.478ccecb.png";